import { useMemo } from 'react';
import { i18nInit } from '@elfsight/lib-i18n';
import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import { PortalNestProvider } from '@elfsight/widget-modal';
import { CustomCSS, createCustomCSSPrefixClassName } from '@elfsight/widget-ui';
import { StorageProvider } from '@elfsight/widget-utils';
import { I18nProvider } from '@lingui/react';
import { meta } from './meta';
import type { SliderSettings } from './types';
import { Widget } from './widget/Widget';

export function Slider({
  widgetId = '',
  customCSS,
  customJS,
  editMode,
  renderThumbnailMode
}: SliderSettings) {
  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.appAlias,
    widgetId
  );
  const i18n = useMemo(() => i18nInit(), []);

  useDefineAPISchema();
  useCustomJS(customJS, editMode || renderThumbnailMode);

  return (
    <I18nProvider i18n={i18n}>
      <StorageProvider widgetId={widgetId} name={meta.appAlias}>
        <PortalNestProvider customCSSClassName={customCSSPrefixClassName}>
          <Widget customCSSPrefixClassName={customCSSPrefixClassName} />
          <CustomCSS
            customCSS={customCSS}
            prefixClassName={customCSSPrefixClassName}
          />
        </PortalNestProvider>
      </StorageProvider>
    </I18nProvider>
  );
}
